export default {
  web: {
    footer: {
      product: "Produkt",
      company: "Unternehmen",
      download: "Download",
      pricing: "Preise",
      bonuses: "Boni",
      copyright: "Alle Rechte vorbehalten.",
    },
  },
};
